import {
  tv
} from "./chunk-N2KXC5ZE.mjs";

// src/components/divider.ts
var divider = tv({
  base: "shrink-0 bg-divider border-none",
  variants: {
    orientation: {
      horizontal: "w-full h-divider",
      vertical: "h-full w-divider"
    }
  },
  defaultVariants: {
    orientation: "horizontal"
  }
});

export {
  divider
};
